import React, { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { IntlProvider } from "react-intl";
import ServiceLocator from "./lib/ServiceLocator";
import App from "./pages/app/app";
import * as actions from "./store/actions";
import project from "../package.json";
import { activeLocale, defaultLocaleId } from "./lib/localeSettings";
import startHeartbeat from "./lib/heartbeat";
import loadLocaleData from "./lib/loadLocaleData";
import setupPhraseAppInContextEditor from "./lib/setupPhraseAppInContextEditor";
import calculateActivePage from "./lib/calculateActivePage";
import { getValidPageByUrl } from "./lib/routes";

import "./index.less";

const serviceLocator = new ServiceLocator();

if (
  !/^crm-appsrv-dev/.test(window.location.hostname) &&
  !/^www.one.com/.test(window.location.hostname) &&
  process.env.NODE_ENV === "development"
) {
  const {
    default: setupDevelopmentEnvironment,
  } = require("./lib/dev/developmentSetup");
  setupDevelopmentEnvironment(serviceLocator, {
    baseUrl: false,
  });
}

function initialize({ store }, activeLocale, rawMessages) {
  const messages = setupPhraseAppInContextEditor(rawMessages);

  let queryParams = new URLSearchParams(window.location.search);
  let pageName = calculateActivePage(
    getValidPageByUrl(queryParams.get("page")),
  );
  queryParams.delete("page");

  window.onpopstate = (e) => {
    queryParams = new URLSearchParams(window.location.search);
    pageName = getValidPageByUrl(queryParams.get("page"));
    queryParams.delete("page");

    store.dispatch(actions.setActiveRoute({ pageName }));
  };

  store.dispatch(actions.goToRoute({ pageName }, true));

  const root = createRoot(document.getElementById("domain-search-app"));
  root.render(
    <IntlProvider
      textComponent="span"
      locale={activeLocale}
      defaultLocale={defaultLocaleId}
      messages={messages}
    >
      <Provider store={store}>
        <StrictMode>
          <App />
        </StrictMode>
      </Provider>
    </IntlProvider>,
  );
}

const htmlElement = document.body.parentElement;
htmlElement.setAttribute("data-domain-search-app-version", project.version);

window.one = window.one || {};
window.one.serviceLocator = serviceLocator;

const { dispatch } = serviceLocator.store;

window.one.actions = Object.entries(actions).reduce(
  (actions, [actionName, action]) => {
    actions[actionName] = (...args) => dispatch(action(...args));
    return actions;
  },
  {},
);

serviceLocator.get("crashReporter").integrate(window);

loadLocaleData(activeLocale, (err, { messages }) => {
  startHeartbeat();
  initialize(serviceLocator, activeLocale, messages);
});
